export default "__VITE_ASSET__JIgHlswG__"